module.exports = __webpack_public_path__ + "img/lifestyle_circle_frame_02.3b7ea433.png";